import { object, string, custom } from 'zod';

import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

import {
  MAX_DEFAULT_SCREEN_NAME_LENGTH,
  MAX_DEFAULT_SCREEN_DESCRIPTION_LENGTH,
  MAX_FILE_SIZE_MB,
} from '../touchpoint.constants';

export const validateImageFile = (file: File): string | null => {
  const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];
  if (!validTypes.includes(file.type)) {
    return 'File must be PNG or JPEG';
  }
  const maxSizeBytes = MAX_FILE_SIZE_MB * 1024 * 1024;
  if (file.size > maxSizeBytes) {
    return `File size must be less than ${MAX_FILE_SIZE_MB}MB`;
  }
  return null;
};

const fileSchema = custom<File | null>((file) => {
  if (!file) {
    return true;
  }
  if (!(file instanceof File)) {
    return false;
  }
  const validationError = validateImageFile(file);
  return !validationError;
}, 'Invalid file');

const schema = object({
  name: string({ required_error: IS_REQUIRED })
    .trim()
    .min(1, IS_REQUIRED)
    .max(
      MAX_DEFAULT_SCREEN_NAME_LENGTH,
      `Name must be less than ${MAX_DEFAULT_SCREEN_NAME_LENGTH} characters`,
    ),
  description: string({ required_error: IS_REQUIRED })
    .trim()
    .min(1, IS_REQUIRED)
    .max(
      MAX_DEFAULT_SCREEN_DESCRIPTION_LENGTH,
      `Description must be less than ${MAX_DEFAULT_SCREEN_DESCRIPTION_LENGTH} characters`,
    ),
  landscapeImage: fileSchema.optional(),
  squareImage: fileSchema.optional(),
  portraitImage: fileSchema.optional(),
  landscapeImageUrl: string().nullable().optional(),
  squareImageUrl: string().nullable().optional(),
  portraitImageUrl: string().nullable().optional(),
});

export const validate = makeValidate(schema);

